/**
 * A utility function that allows defining a reducer as a mapping from action
 * type to *case reducer* functions that handle these action types. The
 * reducer's initial state is passed as the first argument.
 *
 * @param initialState The initial state to be returned by the reducer.
 * @param actionsMap A mapping from action types to action-type-specific
 *   case reducers.
 */
export function createReducer(initialState, actionsMap) {
    return function (state = initialState, action) {
        const caseReducer = actionsMap[action.type];
        return caseReducer ? caseReducer(state, action) : state;
    };
}
